<template>
  <section
    id="work-experience"
    class="flex flex-col justify-around contentarea"
  >
    <h2 class="py-2 mb-1 v-highlight text-h2">
      <router-link class="header-anchor" :to="{ hash: '#work-experience' }"
        >Work Experience</router-link
      >
    </h2>
    <div class="snippet-experiences-024">
      <div class="row flex">
        <div class="item-bullet"></div>
        <div class="item">
          <h4>
            WISTRON ITS INC, Senior Front-end enginner, 2021 年 9 月 - 迄今
          </h4>
        </div>
      </div>
      <div class="row flex">
        <div class="item-bullet"></div>
        <div class="item">
          <h4>
            Newtype Games Limited, Front-end enginner, 2019 年 7 月 - 2021年 3月
          </h4>
          <p class="py-2">
            <b><i>ATFX Client Portal App, ATFX Client Portal Team</i></b
            ><br />
            <span>1. 與超過100人的跨國團隊協同開發</span><br />
            <span
              >2. 負責兩個專案金流串接第三方金流，有Alipay, wechat, 信用卡等 </span
            ><br />
            <span>3. Responsive Web Design </span><br />
            <span
              >4. 使用 技術 Vue.js , React-Native, Element UI, MandMobile UI,
              Kibana, Zeplin
            </span>
          </p>
          <p class="blank_a">
            <span
              ><a
                href="https://login-gm.atfx.com/register?redirect_uri=applyLive&amp;lang=zh-hant&amp;hsCtaTracking=f39fdadf-fab5-48bb-a3b9-d85640f1105d%7C8cba500f-833c-4b6a-9b72-933384be11bb"
                target="_blank"
                rel="nofollow noopener"
                ><span>ATFX Client Portal</span></a
              ><br
            /></span>
          </p>
          <p class="py-2">
            <b><i>Payment Admin System, Front-end Team</i></b
            ><br />
            <span>1. 獨立建制支付管理系統</span><br />
            <span>2. 提供第三方金流渠道的開啟與關閉</span><br />
            <span>3. 交易金額門檻設定</span><br />
            <span>4. 使用技術 Vue.js , Element UI, Docker </span>
          </p>
          <p class="py-2">
            <b><i>Game Platform System, Front-end Team</i></b
            ><br />
            <span>1. 成立一年有超過百萬會員數</span><br />
            <span>2. 與 Android 工程師 串接 SDK 建立完整支付流程</span><br />
            <span>3. 採用 Nuxt lighthouse SEO score 100交易金額門檻設定</span
            ><br />
            <span>4. 使用 Matomo + UTM 追蹤使用者行為</span><br />
            <span>5. 優化 Nuxt 使 I2A 提升 50%</span><br />
            <span>6. 導入 Design token 給 UIUX Team</span><br />
            <span>7. 使用技術 Nuxt, Vuetify UI, Docker, Figma</span><br />
          </p>
        </div>
      </div>
      <div class="row flex">
        <div class="item-bullet"></div>
        <div class="item">
          <h4>ZTRON Inc, Full Stack Engineer, 2018 年 9 月 - 2019年 7月</h4>
          <p class="py-2">
            <span>1. 建制智能家居後台管理系統</span><br />
            <span>2. 後台重構</span><br />
            <span>3. 負責註冊流程，公社開發，瓦斯抄表功能</span><br />
            <span>4. 採用 Aws 結合 Severless Microservice 節省開發成本 </span
            ><br />
            <span
              >5. 使用技術 Vue.js, Vuetify UI, Node.js Express + Serverless,
              Sequelize ORM, PostgreSQL
            </span>
          </p>
        </div>
      </div>
      <div class="row flex">
        <div class="item-bullet item-bullet-last"></div>
        <div class="item">
          <h4>UBIIX Inc, Software Engineer, 2017年 7 月 - 2018 年 9 月</h4>
          <p class="py-2">
            <b><i>Software Engineer，2018 年 6 月 - 2018 年 9 月</i></b
            ><br />
            <span>1. 獨立建制話務分析和管理系統</span><br />
            <span>2. 此系統上線後，快速使系統工程師能掌握並解決盜用問題</span
            ><br />
            <span>3. 使用圖表，視覺話呈現出通話流量分佈，成本，地域</span><br />
            <span>4. 建置 Jenkins 話務分析管理系統 </span><br />
            <span>5. 採用技術 前端 Vue.js, Element UI, EChart.js</span><br />
            <span>6. 採用技術 PHP , MYSQL , Jenkins</span><br />
          </p>
          <p class="py-2">
            <b><i>Software Intern，2017 年 7 月 - 2018 年 6 月</i></b
            ><br />
            <span>1. 開始使用 Git Flow </span><br />
            <span>2. 使用 Jira 做 Issue Tracking System </span><br />
            <span>3. 負責客服管理系統設定機器人＆導入導出 功能</span><br />
            <span>4. 負責語音滿意度調查統計功能 </span><br />
            <span>5. 負責分幾使用率統計功能 </span><br />
            <span>6. 採用技術 前端 Html, Jquery, Chart.js, Vue</span><br />
            <span>7. 採用技術 後端 PHP, phpexcel, Git</span><br />
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup></script>
